module.exports = __webpack_public_path__ + "mo/img/piece-11.a519856b.svg";